/** Lightweight pub/sub so header Add Report can update mounted list pages. */

const listeners = new Set();

export function subscribeReportListEvents(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function emitReportListEvent(event) {
  listeners.forEach((listener) => {
    try {
      listener(event);
    } catch {
      /* ignore listener errors */
    }
  });
}
